module.exports = __webpack_public_path__ + "static/bus.png";